import extend from 'lodash/extend';
import * as ActionTypes from './actionTypes';

const initialState = {
  brokerDetails: {
    response: null,
    status: 'loading',
    error: null,
  },
  brokerList: {
    response: null,
    status: 'loading',
    error: null,
  },
};

export default function detailsContainerReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case ActionTypes.SET_BROKER_DETAILS:
      return extend({}, state, {
        brokerDetails: { ...state?.brokerDetails, response: action.payload, status: 'success' },
      });
    case ActionTypes.SET_BROKER_LIST:
      return extend({}, state, {
        brokerList: { ...state?.brokerDetails, response: action.payload, status: 'success' },
      });
    case ActionTypes.RESET_BROKER_DETAILS:
      return extend({}, state, {
        brokerDetails: initialState.brokerDetails,
      });
    case ActionTypes.RESET_BROKER_LIST:
      return extend({}, state, {
        brokerList: initialState.brokerList,
      });
    default:
      return state;
  }
}